import { useState } from "react";

/**
 * Centralises the "are you sure?" confirmation popup state.
 *
 * Usage:
 *   const confirm = useConfirmPopup();
 *   confirm.prompt("Are you sure?", myAction);
 *   <AreYouSurePopup open={confirm.open} onClick={confirm.action} close={confirm.close} />
 */
export function useConfirmPopup() {
  const [open, setOpen] = useState(false);
  const [text, setText] = useState("");
  const [action, setAction] = useState(() => () => {});

  const prompt = (message, onConfirm) => {
    setText(message);
    // Wrap in arrow so React doesn't call it immediately (useState setter quirk)
    setAction(() => onConfirm);
    setOpen(true);
  };

  const close = () => {
    setOpen(false);
    setText("");
    setAction(() => () => {});
  };

  return { open, text, action, prompt, close };
}
